import request from './base';
import {excludeObjNullValue} from 'utils/common';
import {capitalize} from 'lodash/string';

/**
 * school endpoints
 */
export const fetchSchools = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/schools', q, page, perPage, sortOpts, extraParams);

export const fetchSchool = (schoolId) => request.fetchDetail(`/schools/${schoolId}`);

export const createSchool = (payload) =>
  request.postJSON(
    '/schools',
    excludeObjNullValue({
      name: payload.name,
      address_line_1: payload.addressLine1,
      suburb: payload.suburb,
      postcode: payload.postcode,
      state: payload.state,
      country: payload.country,
      phone_number: payload.phoneNumber,
      notes: payload.notes,
    }),
  );

export const updateSchool = (payload) => {
  const formData = new FormData();
  const data = excludeObjNullValue({
    name: payload.name,
    address_line_1: payload.addressLine1,
    suburb: payload.suburb,
    postcode: payload.postcode,
    state: payload.state,
    country: payload.country,
    phone_number: payload.phoneNumber,
    notes: payload.notes,
    logo: payload.logo,
  });
  for (const [k, v] of Object.entries(data)) {
    formData.append(k, v);
  }
  return request.putForm(`/schools/${payload.schoolId}`, formData);
};

export const deleteSchool = (schoolId, hard = false) => request.deleteReq(`/schools/${schoolId}`, {hard});

export const removeUserFromSchool = (schoolId, userId) => request.deleteReq(`/schools/${schoolId}/users/${userId}`);

export const addExistingUserToSchools = (payload) =>
  request.postJSON(
    `/users/${payload.userId}/schools`,
    excludeObjNullValue({
      school_ids: payload.schoolIds,
    }),
  );

export const unallocateUnusedSubscriptions = (schoolId) =>
  request.putJSON(`/schools/${schoolId}/unallocate-unused-subscriptions`);
